var map = {
	"./one-10.png": 7334,
	"./one-11.png": 3663,
	"./one-12.png": 9012,
	"./one-5.png": 4504,
	"./one-6.png": 1363,
	"./one-7.png": 6138,
	"./one-8.png": 3645,
	"./one-9.png": 7492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2678;